import React from 'react';
import Notifications from './../common/header/notifications';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { REDUCER_NAME, fetchCompanyScore } from './reducer';
import { withComponentId } from './../../common/ComponentIdContext';

class Noti extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.i18n.locale !== this.props.i18n.locale) {
      const { dispatch, id, currentSearch } = this.props;
      dispatch(fetchCompanyScore(currentSearch.code, id));
    }
  }

  render() {
    const { currentSearch = {}, companyScore } = this.props;
    return currentSearch.isBanking || <Notifications data={companyScore} />;
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    i18n: state.i18n,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
    companyScore: state[REDUCER_NAME].listMultiComponent[componentId].score,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(Noti);
